var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "input-group",
        { attrs: { icon: "fa fa-newspaper-o" } },
        [
          _c("v-select", {
            staticClass: "form-control",
            attrs: {
              options: _vm.availableOptions,
              clearable: true,
              label: "label",
              "close-on-select": false,
              multiple: ""
            },
            model: {
              value: _vm.selectedOptions,
              callback: function($$v) {
                _vm.selectedOptions = $$v
              },
              expression: "selectedOptions"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }